<template>
  <div id="app" v-cloak>
    <CookieBanner></CookieBanner>
    <template v-if="!this.$store.getters.getUserRemoveRequestedAt">
      <status-nav v-cloak v-if="displayStatusNavInCurrentRoute"></status-nav>
    </template>
    <template v-else>
      <div class="alert-user-deleted alert alert-danger" role="alert">
        <div class="container">
          <div class="row">
            <div class="col-md-10">
              <b>Il tuo account non sarà più attivo</b>
              dalle ore 23:59 del giorno {{ moment(this.$store.getters.getUserRemoveRequestedAt).format("DD/MM/YYYY") }}
            </div>
            <div class="col-md-2">
              <button class="btn btn-sm btn-primary" @click="undoRemoval">RIATTIVA</button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <navigation
      v-cloak
      v-if="['login', 'index', 'agreements', 'info', '404', 'complete-profile'].indexOf($route.name) == -1"
    ></navigation>
    <router-view />
    <footer-component v-cloak v-if="['info', '404', 'survey'].indexOf(this.$route.name) == -1"></footer-component>
    <message-center></message-center>
    <div class="pulse-container" v-if="showSpinner" v-cloak>
      <div>
        <loader :loading="showSpinner" :color="spinnerColor" size="60px"></loader>
      </div>
      <!-- <div class="loader" v-if="showSpinner">
        <div class="v-bounce v-bounce1" style="height: 60px; width: 60px; position: relative;">
          <div
            class="v-bounce v-bounce2"
            :style="'background-color: '+ $store.state.campaign.css_settings.primary +'; height: 60px; width: 60px; border-radius: 100%; opacity: 0.6; position: absolute; top: 0px; left: 0px;'"
          ></div>
          <div
            class="v-bounce v-bounce3"
            :style="'background-color: '+$store.state.campaign.css_settings.primary +'; height: 60px; width: 60px; border-radius: 100%; opacity: 0.6; position: absolute; top: 0px; left: 0px;'"
          ></div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import Navigation from "./components/Navigation";
import FooterComponent from "./components/Footer";
import MessageCenter from "./components/Campaign/MessageCenter/MessageCenter";
import CookieBanner from "./components/CookieBanner"
import StatusNav from "./components/StatusNav";
import _ from "lodash";

export default {
  name: "app",
  data() {
    return {
      loading: true
    };
  },
  components: {
    Navigation,
    FooterComponent,
    MessageCenter,
    StatusNav,
    CookieBanner
  },
  computed: {
    showSpinner() {
      return this.$store.state.spinnerVisible;
    },
    displayStatusNavInCurrentRoute() {
      if (
        [
          "login",
          "index",
          "agreements",
          "socialLogin",
          "info",
          "404",
          "complete-profile"
        ].indexOf(this.$route.name) !== -1
      ) {
        return false;
      } else if (this.$route.name === "dashboard" && this.$mq !== "sm") {
        return false;
      }

      return true;
    },
    spinnerColor() {
      return _.get(
        this.$store,
        "state.campaign.css_settings.primary",
        "#5F21E0"
      );
    }
  },
  created() {
    if (this.$messaging) {
      this.$messaging.onTokenRefresh(() => {
        this.$messaging
          .getToken()
          .then(refreshedToken => {
            this.pushDeviceInfo(refreshedToken, "web-firebase");
          })
          .catch(err => {
            console.log("Unable to retrieve refreshed token ", err);
          });

        this.$messaging.onMessage(payload => {
          const notificationTitle = payload.title;
          const notificationOptions = {
            body: payload.body,
            icon: "/favicon.ico"
          };

          return self.registration.showNotification(
            notificationTitle,
            notificationOptions
          );
        });
      });
    }
  },
  methods: {
    async undoRemoval() {
      this.$store.commit("showSpinner");
      try {
        await this.$http.get(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/undelete"
        );

        this.$store.commit("updateUserRemoveRequestedAt", null);
        await this.$store.dispatch("getUnreadMessages");
      } catch (e) {
        this.$store.commit("pushMessage", {
          type: "error",
          title: "Error",
          text: "An error occurred"
        });
      }

      this.$store.commit("hideSpinner");
    }
  }
};
</script>

<style lang="scss">
@import "./assets/css/mixins";
@import "./assets/css/fonts.scss";

[v-cloak] {
  display: none;
}

 #app{
      font-family : "DIN Next LT Pro" !important;
      letter-spacing : 1px !important; 
  }

</style>